import {VIEW_TYPES} from "./OtherKeys.jsx";

export const SWIVU_STANDARD_ICONS = {
  [VIEW_TYPES.resources]: "fa-light fa-screwdriver-wrench",
  [VIEW_TYPES.tasks]: "fa-light fa-swap-arrows",
  [VIEW_TYPES.clients]: "fa-light fa-building-user",
  [VIEW_TYPES.users]: "fa-light fa-users",
  [VIEW_TYPES.schedulerView]: "fa-light fa-calendar-days",
  [VIEW_TYPES.planView]: "fa-light fa-diagram-predecessor",
  [VIEW_TYPES.checklists]: "fa-light fa-list-check",
  [VIEW_TYPES.checkgrids]: "fa-light fa-list-check",
  [VIEW_TYPES.notify]: "fa-light fa-bullhorn",
  [VIEW_TYPES.contacts]: "fa-light fa-address-card",
  [VIEW_TYPES.taskBudget]: "fa-light fa-coins",
  [VIEW_TYPES.reminder]: "fa-light fa-alarm-clock",
  [VIEW_TYPES.incentivePoints]: "fa-light fa-award",
  [VIEW_TYPES.clocking]: "fa-light fa-clock",
  [VIEW_TYPES.coverage]: "fa-light fa-chart-tree-map",
  [VIEW_TYPES.promote]: "fa-light fa-sparkles",
  [VIEW_TYPES.workFiles]: "fa-light fa-folder-open",
  [VIEW_TYPES.marketingPages]: "fa-light fa-browser",
  [VIEW_TYPES.site]: "fa-light fa-globe",
  [VIEW_TYPES.leads]: "fa-light fa-inbox",
  [VIEW_TYPES.context]: "fa-light fa-brain",
  [VIEW_TYPES.marketingManifest]: "fa-light fa-file-lines",
  addUser: "fa-light fa-user-plus",
  defaultView: "fa-light fa-layer-group",
}
